import { bidsEndpoints } from './endpoints/bid'
import { commonEndpoints } from './endpoints/common'
import { companiesEndpoints } from './endpoints/companies'
import { dashboardEndpoints } from './endpoints/dashboard'
import { dealsEndpoints } from './endpoints/deal'
import { exportEndpoints } from './endpoints/export'
import { logisticsEndpoints } from './endpoints/logistics'
import { LogisticsKR } from './endpoints/logisticsKR'
import { productsEndpoints } from './endpoints/products'
import { specificationsEndpoints } from './endpoints/specifications'
import { tasksEndpoints } from './endpoints/task'
import { teamsEndpoints } from './endpoints/teams'
import { usersEndpoints } from './endpoints/users'
import { vatsEndpoints } from './endpoints/vats'
import { warehousesEndpoints } from './endpoints/warehouses'
import { usContractsEndpoints } from './endpoints/usContracts'

export const endpoints = {
  ...commonEndpoints,
  ...usersEndpoints,
  ...dealsEndpoints,
  ...companiesEndpoints,
  ...productsEndpoints,
  ...bidsEndpoints,
  ...tasksEndpoints,
  ...dashboardEndpoints,
  ...teamsEndpoints,
  ...logisticsEndpoints,
  ...vatsEndpoints,
  ...specificationsEndpoints,
  ...exportEndpoints,
  ...warehousesEndpoints,
  ...usContractsEndpoints,
  LogisticsKR,
}
